"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collections_1 = require("./collections");
var EventSource = /** @class */ (function () {
    function EventSource() {
        this.listeners = collections_1.createStringMap();
    }
    EventSource.prototype.on = function (eventKey, listener) {
        var listeners = this.listeners[eventKey];
        if (!listeners) {
            listeners = [];
            this.listeners[eventKey] = listeners;
        }
        listeners.push(listener);
    };
    EventSource.prototype.onAny = function (listener) {
        var listeners = this.anyListeners;
        if (!listeners) {
            listeners = [];
            this.anyListeners = listeners;
        }
        listeners.push(listener);
    };
    EventSource.prototype.off = function (eventKey, listener) {
        var listeners = this.listeners[eventKey];
        if (!listeners) {
            return;
        }
        var index = listeners.indexOf(listener);
        if (index >= 0) {
            listeners.splice(index, 1);
        }
    };
    EventSource.prototype.offAny = function (listener) {
        var listeners = this.anyListeners;
        if (!listeners) {
            return;
        }
        var index = listeners.indexOf(listener);
        if (index >= 0) {
            listeners.splice(index, 1);
        }
    };
    EventSource.prototype.trigger = function (eventKey, data) {
        var listeners = this.listeners[eventKey];
        if (listeners) {
            for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                var listener = listeners_1[_i];
                listener(data, eventKey);
            }
        }
        if (this.anyListeners) {
            for (var _a = 0, _b = this.anyListeners; _a < _b.length; _a++) {
                var anyListener = _b[_a];
                anyListener((_c = {}, _c[eventKey] = data, _c), eventKey);
            }
        }
        var _c;
    };
    return EventSource;
}());
exports.EventSource = EventSource;
var EventObserver = /** @class */ (function () {
    function EventObserver() {
        this.unsubscribeByKey = collections_1.createStringMap();
        this.onDispose = [];
    }
    EventObserver.prototype.listen = function (events, eventKey, listener) {
        events.on(eventKey, listener);
        this.onDispose.push(function () { return events.off(eventKey, listener); });
    };
    EventObserver.prototype.listenAny = function (events, listener) {
        events.onAny(listener);
        this.onDispose.push(function () { return events.offAny(listener); });
    };
    EventObserver.prototype.listenOnce = function (events, eventKey, listener) {
        var handled = false;
        var onceListener = function (data, key) {
            handled = true;
            events.off(eventKey, onceListener);
            listener(data, key);
        };
        events.on(eventKey, onceListener);
        this.onDispose.push(function () {
            if (handled) {
                return;
            }
            events.off(eventKey, onceListener);
        });
    };
    EventObserver.prototype.stopListening = function () {
        for (var _i = 0, _a = this.onDispose; _i < _a.length; _i++) {
            var unsubscribe = _a[_i];
            unsubscribe();
        }
        this.onDispose.length = 0;
        for (var key in this.unsubscribeByKey) {
            if (!collections_1.hasOwnProperty(this.unsubscribeByKey, key)) {
                continue;
            }
            var unsubscribers = this.unsubscribeByKey[key];
            for (var _b = 0, unsubscribers_1 = unsubscribers; _b < unsubscribers_1.length; _b++) {
                var unsubscribe = unsubscribers_1[_b];
                unsubscribe();
            }
        }
        this.unsubscribeByKey = {};
    };
    return EventObserver;
}());
exports.EventObserver = EventObserver;
